import React from 'react';
import { Clock } from 'lucide-react';

function TimeSlot({ time, candidate, interviewer, colorClasses, duration, onClick, event, classes = "" }) {
  // Format event start time if available
  const formatTime = (isoString) => {
    if (!isoString) return 'N/A';
    const date = new Date(isoString);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  };

  // Add color luminance check function
  const isDarkColor = (hex) => {
    if (!hex) return false;
    const r = parseInt(hex.substr(1, 2), 16);
    const g = parseInt(hex.substr(3, 2), 16);
    const b = parseInt(hex.substr(5, 2), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance < 0.5;
  };

  const style = interviewer ? { backgroundColor: interviewer?.color || '#ffffff' } : {};

  return (
    <button
      onClick={candidate || interviewer ? onClick : undefined}
      style={style}
      className={`group relative flex items-center justify-center p-1 sm:p-2 min-h-8 h-auto rounded-lg border transition-all hover:shadow-md ${
        interviewer
          ? 'before:content-[attr(data-tooltip)] before:absolute before:hidden hover:before:block before:bg-foreground before:text-background before:border before:border-border before:px-2 before:py-1 before:rounded before:text-xs before:bottom-full before:left-1/2 before:-translate-x-1/2 before:mb-2 before:whitespace-nowrap before:z-10 before:shadow-md'
          : ''
      } ${
        interviewer || candidate
          ? 'border-none'
          : 'border-border hover:border-input'
      } ${classes} ${!interviewer ? colorClasses : ''} ${
        candidate || interviewer ? 'cursor-pointer' : 'cursor-default'
      }`}
      data-tooltip={
        interviewer
          ? `Recruiter: ${interviewer?.name})${
              duration ? ` (${duration} min)` : ''
            }`
          : ''
      }
    >
      {candidate && (
        <div className="flex flex-col items-center text-[10px] sm:text-xs">
          <span className="font-medium truncate max-w-full">
            {candidate?.name || 'Unknown'}
          </span>
          {interviewer && (
            <span className="flex items-center gap-1 mt-1">
              {/* <Clock className="w-3 h-3" /> */}
              Assigned to: {interviewer?.name}
            </span>
          )}
       </div>
      )}
    </button>
  );
}

export default TimeSlot;